import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { lombardActions } from '../+state/lombard.actions';
import { lombardFeature } from '../+state/lombard.reducer';
import * as LombardSelectors from '../+state/lombard.selectors';

@Injectable({ providedIn: 'root' })
export class LombardFacade {
  readonly #store = inject(Store);

  public readonly loading$ = this.#store.select(lombardFeature.selectLoading);
  public readonly lombard$ = this.#store.select(lombardFeature.selectLombard);
  public readonly faqs$ = this.#store.select(lombardFeature.selectFaqs);
  public readonly applying$ = this.#store.select(lombardFeature.selectApplying);
  public readonly shouldDisplayConfirmationModal$ = this.#store.select(LombardSelectors.selectShouldDisplayConfirmationModal);
  public readonly confirmationData$ = this.#store.select(lombardFeature.selectConfirmationData);
  public readonly shouldDisplayTeaser$ = this.#store.select(LombardSelectors.selectShouldDisplayTeaser);
  public readonly hasDismissedOffer$ = this.#store.select(lombardFeature.selectHasDismissedOffer);
  public readonly hasAppliedCredit$ = this.#store.select(lombardFeature.selectHasAppliedCredit);
  public readonly error$ = this.#store.select(lombardFeature.selectError);

  public init(): void {
    this.loadLombard();
    this.#loadFAQs();
  }

  public loadLombard = (): void => this.#store.dispatch(lombardActions.loadLombard());
  public applyForCredit = (credit: number): void => this.#store.dispatch(lombardActions.applyForCredit({ credit }));
  public loadConfirmationData = (): void => this.#store.dispatch(lombardActions.loadConfirmationData());
  public clearConfirmationData = (): void => this.#store.dispatch(lombardActions.clearConfirmationData());
  public dismissTeaser = (): void => this.#store.dispatch(lombardActions.dismissTeaser());
  public dismissOffer = (): void => this.#store.dispatch(lombardActions.dismissOffer());

  #loadFAQs = (): void => this.#store.dispatch(lombardActions.loadFAQs());
}
